module.exports = __webpack_public_path__ + "static/img/gold.2188c692.png";